(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/search-suggestions.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/search-suggestions.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.SearchSuggestions = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.search_suggestions(data);
    },

    collectionEvents: {
      reset: 'render'
    },
    className: 'search-suggestions',
    events: {
      'click a': 'clearSearchSuggestion'
    },

    initialize: function() {
      this.listenTo(this.collection, 'reset', this.render);
    },

    clearSearchSuggestion: function() {
      var self = this;
      setTimeout(function() {
        self.collection.reset();
      }, 50);
    }
  });
})(Backbone, _, svs);


 })(window);